import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '../../modules/authentication/authentication.service';
import { UserService } from 'src/app/services/user/user.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public isMenuCollapsed = false;
  public isLoggedIn = false;
  private destroy$: Subject<void> = new Subject<void>();
  @Output() menuToggle = new EventEmitter(this.isMenuCollapsed);

  constructor(
    public userService: UserService,
    private authService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    // Watch for login status changes
    this.authService.isLoggedIn
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLoggedIn) => {
        if (isLoggedIn) {
          this.isLoggedIn = isLoggedIn;
        }
      });
  }

  menuToggleHandler() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.menuToggle.emit(this.isMenuCollapsed);
  }

  logout() {
    this.authService.logout();
  }

  onUserInfoOpen(isOpen: boolean, dropDownMenuElementRef: any): void {
    if (isOpen) {
      dropDownMenuElementRef?.parentElement?.classList?.add(
        'user-menu-list-cdk-overlay-pane',
      );
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
